var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{attrs:{"id":"topbar"}},[_c('nav',{staticClass:"navbar navbar-expand-lg",attrs:{"id":"navbar"}},[_c('p',{staticClass:"mb-0 my-auto font-size-16 d-none d-lg-block"},[_vm._v(" POS - Partial Offering System ")])])])
}]

export { render, staticRenderFns }